import { useEffect } from 'react'
import { useFeatureFlagStore } from './useFeatureFlagStore'

/**
 * FeatureFlagBootstrap fires the single /api/flags fetch on app mount.
 * Renders nothing. Mount once inside the top-level layout (alongside
 * <NavBar />) so it runs on every page load — including public pages,
 * where the response is the sparse audience='everyone'-only map.
 */
export default function FeatureFlagBootstrap() {
  const load = useFeatureFlagStore((s) => s.load)
  useEffect(() => {
    load()
  }, [load])
  return null
}
